import Form from "common/Form/Form.tsx";
import Input from "common/Inputs/Input.tsx";
import { PasswordSection } from "features/auth/PasswordSection.tsx";
import Button from "common/Buttons/Button.tsx";
import { ConnectEmailRequest, ConnectEmailResponse } from "@shared/types";
import { EMAIL_FORM_ITEM_RULES } from "features/auth/constants.ts";
import { DarkModePassword, Password } from "common/Icons/Icons.tsx";
import { useTheme } from "styled-components";
import { sharedLib } from "@shared/services/shared.service.ts";
import { displayResultMessage } from "utils/misc.tsx";
import { pick } from "lodash";
import { NewLookFormActions } from "features/settings/NewLook/NewLookFormPanel.tsx";

interface EmailAndPasswordProps {
  nextStep: () => void;
  setEmail: (email: string) => void;
  setEmailValidatorUuid: (emailValidatorUuid: string) => void;
}

const EmailAndPassword = ({
  nextStep,
  setEmail,
  setEmailValidatorUuid,
}: EmailAndPasswordProps) => {
  const theme = useTheme();
  const [connectEmail, { isLoading }] =
    sharedLib.sharedApi.settings.useConnectEmailMutation();

  const PasswordIcon = theme.isDarkMode ? DarkModePassword : Password;

  const onFinish = async (values: ConnectEmailRequest) => {
    displayResultMessage(
      connectEmail(pick(values, ["email", "password"])).unwrap()
    )
      .then((response: ConnectEmailResponse) => {
        setEmail(values.email);
        setEmailValidatorUuid(response.email_validator_uuid);
        nextStep();
      })
      .catch(() => {});
  };

  return (
    <div>
      {!theme.isNewLook && <PasswordIcon style={ICON_STYLE} />}
      <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          name="email"
          label="Email"
          rules={EMAIL_FORM_ITEM_RULES}
          style={{ margin: "0 0 16px" }}
        >
          <Input size={theme.isNewLook ? undefined : "large"} />
        </Form.Item>
        <PasswordSection
          size={theme.isNewLook ? undefined : "large"}
          showPlaceholder={false}
          showConfirm={true}
        />
        {theme.isNewLook ? (
          <NewLookFormActions>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Continue
            </Button>
          </NewLookFormActions>
        ) : (
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%" }}
            loading={isLoading}
          >
            Continue
          </Button>
        )}
      </Form>
    </div>
  );
};

export default EmailAndPassword;

export const ICON_STYLE = {
  display: "block",
  width: 125,
  height: "auto",
  margin: "0 auto 20px auto",
};
